<template>
  <div class="container page account-setting-page password-setting-page login-password-page">
    <van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar">
      <template #left>
        <button class="nav-back" type="button" aria-label="Back" @click="back()">
          <van-icon name="arrow-left" />
        </button>
      </template>
    </van-nav-bar>
    <main class="setting-content">
      <div class="setting-hero">
        <div class="setting-hero-icon"><van-icon name="lock" /></div>
        <div>
          <div class="setting-kicker">Account security</div>
          <h1>{{$t('setting.login_pwd_tip')}}</h1>
          <p>Create a private password that is different from your transaction PIN.</p>
        </div>
      </div>
      <van-cell-group class="settings-form-card password-form-card">
        <van-field v-model="old_password" left-icon="lock" :type="showOldPassword ? 'text' : 'password'" :right-icon="showOldPassword ? 'eye-o' : 'closed-eye'" autocomplete="current-password" :label="$t('setting.old_pwd')" :placeholder="$t('setting.old_pwd_tip')" @click-right-icon="showOldPassword = !showOldPassword" />
        <van-field v-model="o_new_password" left-icon="shield-o" :type="showNewPassword ? 'text' : 'password'" :right-icon="showNewPassword ? 'eye-o' : 'closed-eye'" autocomplete="new-password" :label="$t('setting.new_pwd')" :placeholder="$t('setting.new_pwd_tip')" @click-right-icon="showNewPassword = !showNewPassword" />
        <van-field v-model="t_new_password" left-icon="passed" :type="showConfirmPassword ? 'text' : 'password'" :right-icon="showConfirmPassword ? 'eye-o' : 'closed-eye'" autocomplete="new-password" :label="$t('setting.new_pwd')" :placeholder="$t('setting.new_again_tip')" @click-right-icon="showConfirmPassword = !showConfirmPassword" />
      </van-cell-group>
      <p class="setting-note"><van-icon name="shield-o" /> You will be signed out after the password is updated.</p>
      <van-button class="sub-btn settings-primary-button" type="primary" @click="save()">{{$t("setting.save")}}</van-button>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password:"",
      t_new_password:"",
      old_password:"",
      showOldPassword:false,
      showNewPassword:false,
      showConfirmPassword:false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      if(this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.old_password === "" || this.old_password === null || this.old_password === undefined){
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if(this.o_new_password !== this.t_new_password){
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      this.$http({
        method: 'get',
        data:{
          old_password:this.old_password,
          new_password:this.o_new_password,
        },
        url: 'user_set_loginpw'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          setTimeout(() => {
            localStorage.clear()
            this.$router.push("Login")
          }, 500);

        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 0.37333rem;;
  line-height: 0.8rem;
}
.sub-btn{
  margin: 1.33333rem 0 0 10%;
  width: 80%;
  height: 1.17333rem;
  border-radius: 1.06667rem;
  color: #fff;
  background: #cacaca;
  border: 0;
  background: linear-gradient(270deg, #5b60df, #5b60df);
  font-size: 4vw;
}
</style>
